<template>
  <div
    data-component="app-launcher-versions-option"
    :class="{ 'is-active': isActive }"
    @click="$emit('click')"
  >
    <span data-text="version">
      {{ version }}
    </span>

    <div
      v-if="tags.length"
      class="tags"
    >
      <or-tag
        v-for="(tag, index) of tags"
        :key="index"
        :data-color="tag.color"
      >
        {{ tag.content }}
      </or-tag>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue-demi';
import { OrTagV3 as OrTag } from '@onereach/ui-components-25';

export default defineComponent({
  name: 'AppLauncherVersionsOption',
  components: { OrTag },
  props: {
    version: {
      type: String,
      default: '',
    },
    isActive: Boolean,
    isInitial: Boolean,
    needsDataUpdate: Boolean,
  },
  emits: ['click'],
  computed: {
    tags() {
      if (this.isInitial) {
        return [{
          content: this.$t('HITL.app-launcher.versions-option-tags.active'),
          color: '',
        }];
      }

      if (this.needsDataUpdate) {
        return [{
          content: this.$t('HITL.app-launcher.versions-option-tags.needs-db-update'),
          color: 'warning',
        }];
      }

      return [];
    },
  },
});
</script>

<style lang="scss" scoped>
@use '@/styles' as *;

[data-component='app-launcher-versions-option'] {
  display: flex;
  align-items: center;
  gap: var(--s-3);

  &.is-active {
    [data-text='version'] {
      font-weight: var(--fw-1);
    }
  }

  [data-text='version'] {
    @include text-overflow;
  }

  .tags {
    display: flex;
    gap: var(--s-3);
    margin-left: auto;

    [data-color='warning'] {
      background: var(--or-c-warning-container);
    }
  }
}
</style>
